import React from 'react';
import styles from '../RateView.module.css';
import FilterLabel from './FilterLabel';

class FilterOneField extends React.Component {

	constructor(props) {
		super(props);
		let rateView = props.rateView;
		let filterValue = '';
		if( rateView.rvContext && rateView.rvContext.filtersInitData ) {
			for(let f of rateView.rvContext.filtersInitData) {
				if( f.predicateId == props.filter.predicateId ) {
					filterValue = f.value;
					break;
				}
			}
		}
		this.state = {
			value: filterValue
		}
		if( filterValue )
			this.updateQueryByValue( filterValue );
	}
	componentDidMount() {
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}
	
	clearFilter = () => {
		this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		this.setState({value: ''});
	}
	handleEdit = e => {
		let value = e.target.value; //.trim();
		this.setValue( value );
	}	
	setValue = (value) => {
		this.setState({value: value});
		this.props.rateView.clearData();
		let trimmedValue = value.trim();
		if( trimmedValue == '' ) {
			this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
			return;
		}
		this.updateQueryByValue( trimmedValue );
	}
	updateQueryByValue = (value) => {
		let q = this.props.rateView.query;
		let indexFilter = -1;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			q.listPredicate.push( {
				predicateId: this.props.filter.predicateId,
				conditionId: this.props.filter.conditionId,
				value: value
			} );
		} else {
			q.listPredicate[indexFilter].value = value;
		}
	}
	
	fetchProfile = () => {
		if( this.state.value.trim() )
			return {filterId: this.props.filter.predicateId, value: this.state.value};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.setValue( profile.value );
	}
	
	render() {
		let filter = this.props.filter;
		return (
			<div className={styles.divFilter}>
				<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				<div className={styles.divFilterInput}>
					<input className={styles.inputFilterValue} type='text' value={this.state.value} onChange={this.handleEdit}/>
				</div>
			</div>
		);
	}	
}

export default FilterOneField;
